import PropTypes from 'prop-types';
import { Text, Button } from '@a0/quantum-web';
import Logo from '../../shared/Logo';
import dictionary from '../dictionary';
import Chevron from '../icons/chevron';
import sections from './sections';
import * as S from './styled';

const Desktop = ({ dark, devHomeUrl, topBannerOpen }) => (
  <S.DesktopWrapper role="navigation" dark={dark} aria-label="top-navigation">
    <S.LogoContainer
      rel="external"
      aria-label="Homepage link"
      href={devHomeUrl}
    >
      <Logo alt="Auth0 Developer Logo" />
    </S.LogoContainer>
    <S.Menu role="menubar">
      {dictionary.sections.map((section) => (
        <S.NavItem
          role="menuitem"
          aria-haspopup="true"
          tabIndex={0}
          onMouseDown={(e) => e.preventDefault()}
          key={section.id}
        >
          <S.NavItemTitle>
            <Text type="Paragraph" size="xsmall" margin="0">
              {section.text} <Chevron />
            </Text>
          </S.NavItemTitle>
          <S.NavContent extraSpacing={topBannerOpen}>
            {sections[section.id]}
          </S.NavContent>
        </S.NavItem>
      ))}
      <S.ButtonsWrapper>
        {dictionary.buttons.map(
          (button) =>
            button.typeDesktop !== 'none' && (
              <Button
                tabIndex={0}
                key={button.text}
                buttonType={button.typeDesktop}
                href={button.url}
                size="small"
              >
                {button.text}
              </Button>
            ),
        )}
      </S.ButtonsWrapper>
    </S.Menu>
  </S.DesktopWrapper>
);

Desktop.propTypes = {
  dark: PropTypes.bool.isRequired,
  devHomeUrl: PropTypes.string.isRequired,
  topBannerOpen: PropTypes.bool.isRequired,
};

export default Desktop;
